// projects/humanresources-common-shared/assets/i18n/*/hr-com-code-text.json
export class HrCommonCodeTextKey {
    private static readonly keyPrefix = 'hrCommonCodeText';
    public static listTitle = `${HrCommonCodeTextKey.keyPrefix}.listTitle`;
    public static pageHeader = `${HrCommonCodeTextKey.keyPrefix}.pageHeader`;
    public static table = `${HrCommonCodeTextKey.keyPrefix}.table`;
    public static info = `${HrCommonCodeTextKey.keyPrefix}.info`;
    public static discriminator = `${HrCommonCodeTextKey.keyPrefix}.discriminator`;
    public static eyeColor = `${HrCommonCodeTextKey.keyPrefix}.eyeColor`;
    public static hairColor = `${HrCommonCodeTextKey.keyPrefix}.hairColor`;
    public static reasonStop = `${HrCommonCodeTextKey.keyPrefix}.reasonStop`;
    public static hrmType = `${HrCommonCodeTextKey.keyPrefix}.hrmType`;
    public static academicTitle = `${HrCommonCodeTextKey.keyPrefix}.academicTitle`;
    public static allowanceType = `${HrCommonCodeTextKey.keyPrefix}.allowanceType`;
    public static maritalStatus = `${HrCommonCodeTextKey.keyPrefix}.maritalStatus`;
    public static serviceClass = `${HrCommonCodeTextKey.keyPrefix}.serviceClass`;
    public static awardAuthority = `${HrCommonCodeTextKey.keyPrefix}.awardAuthority`;
    public static awardType = `${HrCommonCodeTextKey.keyPrefix}.awardType`;
    public static paymentWay = `${HrCommonCodeTextKey.keyPrefix}.paymentWay`;
    public static kindOfDept = `${HrCommonCodeTextKey.keyPrefix}.kindOfDept`;
    public static courtStage = `${HrCommonCodeTextKey.keyPrefix}.courtStage`;
    public static lawsuitSubtype = `${HrCommonCodeTextKey.keyPrefix}.lawsuitSubtype`;
    public static lawsuitType = `${HrCommonCodeTextKey.keyPrefix}.lawsuitType`;
    public static examType = `${HrCommonCodeTextKey.keyPrefix}.examType`;
    public static subExamType = `${HrCommonCodeTextKey.keyPrefix}.subExamType`;
    public static assignmentMethod = `${HrCommonCodeTextKey.keyPrefix}.assignmentMethod`;
    public static assignmentReason = `${HrCommonCodeTextKey.keyPrefix}.assignmentReason`;
    public static bankCrateCode = `${HrCommonCodeTextKey.keyPrefix}.bankCrateCode`;
    public static leaveMethod = `${HrCommonCodeTextKey.keyPrefix}.leaveMethod`;
    public static leaveReason = `${HrCommonCodeTextKey.keyPrefix}.leaveReason`;
    public static specialServiceCode = `${HrCommonCodeTextKey.keyPrefix}.specialServiceCode`;
    public static realEstateType = `${HrCommonCodeTextKey.keyPrefix}.realEstateType`;
    public static diagnosticType = `${HrCommonCodeTextKey.keyPrefix}.diagnosticType`;
    public static examinationResult = `${HrCommonCodeTextKey.keyPrefix}.examinationResult`;
    public static laboratoryTest = `${HrCommonCodeTextKey.keyPrefix}.laboratoryTest`;
    public static medicalSection = `${HrCommonCodeTextKey.keyPrefix}.medicalSection`;
    public static nurseProcess = `${HrCommonCodeTextKey.keyPrefix}.nurseProcess`;
    public static reportType = `${HrCommonCodeTextKey.keyPrefix}.reportType`;
    public static reasonOfIssue = `${HrCommonCodeTextKey.keyPrefix}.reasonOfIssue`;
    public static branchCode = `${HrCommonCodeTextKey.keyPrefix}.branchCode`;
    public static rankCode = `${HrCommonCodeTextKey.keyPrefix}.rankCode`;
    public static educationGroup = `${HrCommonCodeTextKey.keyPrefix}.educationGroup`;
    public static educationSubtype = `${HrCommonCodeTextKey.keyPrefix}.educationSubtype`;
    public static skinColor = `${HrCommonCodeTextKey.keyPrefix}.skinColor`;
    public static limb = `${HrCommonCodeTextKey.keyPrefix}.limb`;
    public static specialSituationDegree = `${HrCommonCodeTextKey.keyPrefix}.specialSituationDegree`;
    public static specialSituationType = `${HrCommonCodeTextKey.keyPrefix}.specialSituationType`;
    public static hierarchyGroup = `${HrCommonCodeTextKey.keyPrefix}.hierarchyGroup`;
    public static objectConnect = `${HrCommonCodeTextKey.keyPrefix}.objectConnect`;
    public static peopleStatus = `${HrCommonCodeTextKey.keyPrefix}.peopleStatus`;
    public static make = `${HrCommonCodeTextKey.keyPrefix}.make`;
    public static eduInstitution = `${HrCommonCodeTextKey.keyPrefix}.eduInstitution`;
    public static faculty = `${HrCommonCodeTextKey.keyPrefix}.faculty`;
    public static serviceCause = `${HrCommonCodeTextKey.keyPrefix}.serviceCause`;
    public static languageLevel = `${HrCommonCodeTextKey.keyPrefix}.languageLevel`;
    public static languageType = `${HrCommonCodeTextKey.keyPrefix}.languageType`;
    public static syndicateDef = `${HrCommonCodeTextKey.keyPrefix}.syndicateDef`;
    public static weaponTradeMark = `${HrCommonCodeTextKey.keyPrefix}.weaponTradeMark`;
    public static object = `${HrCommonCodeTextKey.keyPrefix}.object`;
    public static branchOfStudy = `${HrCommonCodeTextKey.keyPrefix}.branchOfStudy`;
    public static employeeType = `${HrCommonCodeTextKey.keyPrefix}.employeeType`;
    public static wtGroup = `${HrCommonCodeTextKey.keyPrefix}.wtGroup`;
    public static workArea = `${HrCommonCodeTextKey.keyPrefix}.workArea`;
    public static search = `${HrCommonCodeTextKey.keyPrefix}.search`;
    public static discriminatorValues = `${HrCommonCodeTextKey.keyPrefix}.discriminatorValues`;
    public static criteria = `${HrCommonCodeTextKey.keyPrefix}.criteria`;
    public static criteriaType = `${HrCommonCodeTextKey.keyPrefix}.criteriaType`;
    public static matter = `${HrCommonCodeTextKey.keyPrefix}.matter`;
    public static kindType = `${HrCommonCodeTextKey.keyPrefix}.kindType`;
    public static kindText = `${HrCommonCodeTextKey.keyPrefix}.kindText`;
    public static orderLevel = `${HrCommonCodeTextKey.keyPrefix}.orderLevel`;
    public static orderLevelConflictHeader = `${HrCommonCodeTextKey.keyPrefix}.orderLevelConflictHeader`;
    public static orderLevelConflictMessage = `${HrCommonCodeTextKey.keyPrefix}.orderLevelConflictMessage`;
    public static findNextOrderLevel = `${HrCommonCodeTextKey.keyPrefix}.findNextOrderLevel`;
}
